import React, { useEffect } from "react";
import { FormField } from "./FormField";
import styles from "./styles.module.scss";
import { useFormStore } from "src/store/dataEntryForm";
import { Select } from "antd";

interface SearchQueryAsinFormProps {
  formId: string;
}

const asinOptions = [
  { value: "B09G9F31QK", label: "B09G9F31QK - Premium iPhone Case" },
  { value: "B08CZVGGL5", label: "B08CZVGGL5 - Waterproof Case" },
  { value: "B07RJWMN89", label: "B07RJWMN89 - Rugged Protection Case" },
  { value: "B091HY14TL", label: "B091HY14TL - Clear iPhone Case" },
  { value: "B07ZPC98WW", label: "B07ZPC98WW - Leather Wallet Case" },
];

const searchQueriesOptions = [
  { value: "iphone case", label: "iPhone Case" },
  { value: "phone accessories", label: "Phone Accessories" },
  { value: "protective phone case", label: "Protective Phone Case" },
  { value: "iphone 14 case", label: "iPhone 14 Case" },
  { value: "slim phone case", label: "Slim Phone Case" },
];

const trendsOptions = [
  { value: "increasing", label: "Increasing" },
  { value: "decreasing", label: "Decreasing" },
  { value: "stable", label: "Stable" },
];

export const SearchQueryAsinForm: React.FC<SearchQueryAsinFormProps> = ({
  formId,
}) => {
  const { initializeForm, resetForm, updateFormField, formData } =
    useFormStore();

  const handleAsinChange = (value: string) => {
    updateFormField(formId, "asin", value);
  };

  const handleSearchQueryChange = (value: string[]) => {
    updateFormField(formId, "searchQuery", value);
  };

  const handleSearchVolumeTrendsChange = (value: string) => {
    updateFormField(formId, "searchVolumeTrends", value);
  };

  useEffect(() => {
    initializeForm(formId, {
      asin: "",
      searchQuery: [],
      clickSharePerQuery: "",
      purchaseRatePerQuery: "",
      searchVolumeTrends: "",
      rankingPosition: "",
    });

    return () => resetForm(formId);
  }, [formId, initializeForm, resetForm]);

  const asinValue = formData[formId]?.asin ?? "";
  const searchQueryValue = formData[formId]?.searchQuery ?? [];
  const searchVolumeTrendsValue = formData[formId]?.searchVolumeTrends ?? "";

  return (
    <div className={styles.addSkuContainer}>
      {/* ASIN */}
      <div className={styles.row}>
        <div className={styles.fullWidthSelect}>
          <label htmlFor="asin-select" className={styles.fieldLabel}>
            ASIN
          </label>

          <Select
            id="asin-select"
            placeholder="Select ASIN"
            value={asinValue ?? undefined}
            onChange={handleAsinChange}
            options={asinOptions}
            className={styles.fullWidthSelect}
            allowClear
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            popupClassName="custom-select-dropdown"
          />
        </div>
      </div>

      {/* Search Queries Associated with ASIN */}
      <div className={styles.row}>
        <div className={styles.fullWidthSelect}>
          <label htmlFor="asin-select-associated" className={styles.fieldLabel}>
            Search Queries Associated with ASIN
          </label>
          <Select
            id="asin-select-associated"
            mode="multiple"
            placeholder="Select search queries"
            value={searchQueryValue}
            onChange={handleSearchQueryChange}
            options={searchQueriesOptions}
            className={styles.fullWidthSelect}
            maxTagCount="responsive"
            allowClear
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            popupClassName="custom-select-dropdown"
          />
        </div>
      </div>

      {/* Other fields */}
      <div className={styles.row}>
        <FormField
          formId={formId}
          fieldName="clickSharePerQuery"
          label="Click Share Per Query, %"
          placeholder=""
          type="number"
          size="small"
        />
        <FormField
          formId={formId}
          fieldName="purchaseRatePerQuery"
          label="Purchase Rate Per Query, %"
          placeholder=""
          type="number"
          size="small"
        />
      </div>

      <div className={styles.row}>
        <div className={styles.halfWidthSelect}>
          <label htmlFor="asin-select-trend" className={styles.fieldLabel}>
            Search Volume Trends
          </label>
          <Select
            id="asin-select-trend"
            placeholder="Select trend"
            size="small"
            allowClear
            showSearch
            value={searchVolumeTrendsValue ?? undefined}
            onChange={handleSearchVolumeTrendsChange}
            options={trendsOptions}
            className={styles.halfWidthSelect}
            popupClassName="custom-select-dropdown"
          />
        </div>
        <FormField
          formId={formId}
          fieldName="rankingPosition"
          label="Ranking position"
          placeholder=""
          type="number"
          size="small"
        />
      </div>
    </div>
  );
};
